import styled from "styled-components";

export const MediaPartnersWrapper = styled.div`
  overflow: hidden;

  .container {
    /* margin-top: 6rem; */
    padding-bottom: 6rem;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  /* text-transform: capitalize; */
  /* background: linear-gradient(#008bda, #a100d5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; */
  text-align: center;
  color: #032b88;

  @media (max-width: 756px) {
    font-size: 2.5rem;
  }
`;

export const MarqueeContainer = styled.div`
  margin-top: 6rem;

  img {
    margin-left: 10rem;

    @media (max-width: 767.98px) {
      margin-left: 5rem;
    }
  }
`;
